// Hide product badges when not on first image - Mobile-friendly version
(function() {
  // Track which sliders we've already attached to
  const attachedSliders = new WeakSet();
  
  function updateBadgeVisibility(container, slideIndex) {
    if (!container) return;
    
    const badges = container.querySelectorAll('.x-badge-container');
    const shouldShow = slideIndex === 0;
    
    badges.forEach(badge => {
      badge.style.transition = 'opacity 0.3s ease';
      badge.style.opacity = shouldShow ? '1' : '0';
      badge.style.pointerEvents = shouldShow ? 'auto' : 'none';
    });
  }
  
  function attachToSplide(splideElement, container) {
    // Avoid attaching multiple times
    if (attachedSliders.has(splideElement)) return;
    
    const splide = splideElement.splide;
    if (!splide) return;
    
    attachedSliders.add(splideElement);
    
    // Listen for slide changes
    splide.on('move', function(newIndex) {
      updateBadgeVisibility(container, newIndex);
    });
    
    // Also handle mounted event for initial state
    splide.on('mounted', function() {
      updateBadgeVisibility(container, splide.index);
    });
    
    // Set initial state immediately
    updateBadgeVisibility(container, splide.index);
  }
  
  function findAndAttachSliders() {
    // Find all product media containers
    document.querySelectorAll('[id^="product-media-"]').forEach(container => {
      // Find the Splide slider element within this container
      const splideElement = container.querySelector('.x-splide, .splide');
      
      if (splideElement && splideElement.splide) {
        attachToSplide(splideElement, container);
      }
    });
    
    // Also check for media gallery containers (alternative structure)
    document.querySelectorAll('[id^="media-gallery-"]').forEach(gallery => {
      if (gallery.splide) {
        const container = gallery.closest('[id^="product-media-"]');
        if (container) {
          attachToSplide(gallery, container);
        }
      }
    });
  }
  
  function init() {
    // Initial attempt
    findAndAttachSliders();
    
    // Retry after a short delay for dynamically loaded content
    setTimeout(findAndAttachSliders, 500);
    setTimeout(findAndAttachSliders, 1500);
    setTimeout(findAndAttachSliders, 3000);
    
    // Listen for Splide ready events (Eurus dispatches these)
    document.addEventListener('eurus:splide-ready', findAndAttachSliders);
    
    // Listen for any custom splide ready events
    const observer = new MutationObserver((mutations) => {
      let shouldCheck = false;
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && (
              node.classList?.contains('x-badge-container') ||
              node.querySelector?.('.x-badge-container')
            )) {
              shouldCheck = true;
            }
          });
        }
      });
      if (shouldCheck) {
        setTimeout(findAndAttachSliders, 100);
      }
    });
    
    // Watch for badge containers being added
    document.querySelectorAll('[id^="product-media-"]').forEach(container => {
      observer.observe(container, { childList: true, subtree: true });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-init on Shopify section events
  document.addEventListener('shopify:section:load', () => {
    setTimeout(init, 500);
  });
  
  // Also try on window load for slower connections
  window.addEventListener('load', () => {
    setTimeout(findAndAttachSliders, 1000);
  });
})();